// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUpCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PUpCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PUpCircleOutlined = function PUpCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUpCircleOutlinedSvg
  }));
};

PUpCircleOutlined.displayName = 'PUpCircleOutlined';
export default React.forwardRef(PUpCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUpCircleOutlined.js
// module id = 3703
// module chunks = 0